/* Curated positive-only reaction set for PrepMasters Phase 2 feed.
 * Excludes any emoji that can be weaponised for harassment/sarcasm/bullying:
 *   - No 😂 (used sarcastically), 🤡 / 💩 / 🖕 (insults), skull / sad faces, etc.
 *   - Only celebratory, supportive, study-relevant glyphs.
 */
export const REACTION_EMOJIS = [
  "🎉", "🎊", "👏", "🙌", "🔥", "❤️", "💯", "✨", "🌟", "⭐",
  "🏆", "🎯", "🚀", "💪", "🧠", "📚", "✅", "👍", "😊", "😄",
  "😍", "🤩", "🥳", "💖", "💙", "💚", "💛", "💜", "📈", "🎓",
];

export const REACTION_LABEL = {
  "🎉": "Celebrate", "🎊": "Party", "👏": "Applause", "🙌": "Cheer",
  "🔥": "On fire", "❤️": "Love", "💯": "Perfect", "✨": "Shine",
  "🌟": "Star", "⭐": "Star", "🏆": "Trophy", "🎯": "Bullseye",
  "🚀": "Lift off", "💪": "Strong", "🧠": "Smart", "📚": "Studious",
  "✅": "Done", "👍": "Thumbs up", "😊": "Happy", "😄": "Joy",
  "😍": "Adore", "🤩": "Amazed", "🥳": "Party", "💖": "Heart",
  "💙": "Heart", "💚": "Heart", "💛": "Heart", "💜": "Heart",
  "📈": "Trending", "🎓": "Graduating",
};
